import React from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

const portalDiv = document.getElementById("portal");
export function Modal({ children }) {
  return createPortal(
    <div className='ModalBack'>
      {children}
    </div>,
    portalDiv
  )
}